import {
  GET_JEWELSBYVALUE_REQUESTED,
  GET_JEWELSBYVALUE_SUCCESS,
  GET_JEWELSBYVALUE_FAILED,
  GET_CLIENTFACETS_REQUESTED,
  GET_CLIENTFACETS_SUCCESS,
  GET_CLIENTFACETS_FAILED,
  GET_SEARCHCLIENTS_REQUESTED,
  GET_SEARCHCLIENTS_SUCCESS,
  GET_SEARCHCLIENTS_FAILED,
  GET_DEALFACETS_REQUESTED,
  GET_DEALFACETS_SUCCESS,
  GET_DEALFACETS_FAILED,
  GET_SEARCHDEALS_REQUESTED,
  GET_SEARCHDEALS_SUCCESS,
  GET_SEARCHDEALS_FAILED,
  GET_CRIMINAL_REQUESTED,
  GET_CRIMINAL_SUCCESS,
  GET_CRIMINAL_FAILED,
  SEARCH_RESET,
  GET_GOVERNMENT_AGENCY_REQUESTED,
  GET_GOVERNMENT_AGENCY_SUCCESS,
  GET_GOVERNMENT_AGENCY_FAILED,
  FETCH_DEAL_NUMBERS_REQUEST,
  FETCH_DEAL_NUMBERS_SUCCESS,
  FETCH_DEAL_NUMBERS_FAILURE,
  GET_GLOBALSEARCH_REQUESTED,
} from './actionTypes'

export const searchJewels = (value, size) => ({
  type: GET_JEWELSBYVALUE_REQUESTED,
  payload: {
    value,
    size
  }
})

export const searchJewelsSuccess = payload => ({
  type: GET_JEWELSBYVALUE_SUCCESS,
  payload
})

export const searchJewelsFailed = payload => ({
  type: GET_JEWELSBYVALUE_FAILED,
  payload
})

export const getClientFacets = (payload) => ({ 
  type: GET_CLIENTFACETS_REQUESTED,
  payload
})

export const getClientFacetsSuccess = payload => ({
  type: GET_CLIENTFACETS_SUCCESS,
  payload
})

export const getClientFacetsFailed = payload => ({
  type: GET_CLIENTFACETS_FAILED,
  payload
})

export const searchClients = (payload) => ({
  type: GET_SEARCHCLIENTS_REQUESTED,
  payload,
})

export const searchClientsSuccess = payload => ({
  type: GET_SEARCHCLIENTS_SUCCESS,
  payload
})

export const searchClientsFailed = payload => ({
  type: GET_SEARCHCLIENTS_FAILED,
  payload
})

export const globalSearch = (payload) => ({
  type: GET_GLOBALSEARCH_REQUESTED,
  payload,
})

export const getDealFacets = (payload) => ({
  type: GET_DEALFACETS_REQUESTED,
  payload,
})

export const getDealFacetsSuccess = payload => ({
  type: GET_DEALFACETS_SUCCESS,
  payload
})

export const getDealFacetsFailed = payload => ({
  type: GET_DEALFACETS_FAILED,
  payload
})

export const searchDeals = (payload) => ({
  type: GET_SEARCHDEALS_REQUESTED,
  payload,
})

export const searchDealsSuccess = payload => ({
  type: GET_SEARCHDEALS_SUCCESS,
  payload
})

export const searchDealsFailed = payload => ({
  type: GET_SEARCHDEALS_FAILED,
  payload
})

export const searchCriminal = payload => ({
  type: GET_CRIMINAL_REQUESTED,
  payload,
})

export const searchCriminalSuccess = payload => ({
  type: GET_CRIMINAL_SUCCESS,
  payload
})

export const searchCriminalFailed = payload => ({
  type: GET_CRIMINAL_FAILED,
  payload
})

export const searchGovernmentAgency = payload => ({
  type: GET_GOVERNMENT_AGENCY_REQUESTED,
  payload
})

export const searchGovernmentAgencySuccess = payload => ({
  type: GET_GOVERNMENT_AGENCY_SUCCESS,
  payload
})

export const searchGovernmentAgencyFailed = payload => ({
  type: GET_GOVERNMENT_AGENCY_FAILED,
  payload
})

export const resetSearch = () => ({
  type: SEARCH_RESET
})

export const fetchDealNumbersRequest = (ids) => ({
  type: FETCH_DEAL_NUMBERS_REQUEST,
  payload: ids,
});

export const fetchDealNumbersSuccess = (dealNumberMap) => ({
  type: FETCH_DEAL_NUMBERS_SUCCESS,
  payload: dealNumberMap,
});

export const fetchDealNumbersFailed = (error) => ({
  type: FETCH_DEAL_NUMBERS_FAILURE,
  payload: error,
});
